import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { COMMON_FLAGS, FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import * as FIELDS from '../../fields';
import { SPENT } from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { DCO_CAMPAIGN_CREATIVE_REPORT_ID } from './dcoCampaignCreativeReportId';
import graph from './graph';
import { customColumns, performanceColumns, setupColumns, defaultColumns } from './reportPresets';

export const dcoCreativeReportConfig = {
    id: DCO_CAMPAIGN_CREATIVE_REPORT_ID,
    label: 'DCO Campaign Creative',
    accountConfigurations: {
        [FEATURE_FLAGS.IS_DCO_ACCOUNT]: 'true',
    },
    commonConfigurations: {
        [COMMON_FLAGS.DCO_CREATIVE_TEMPLATE_REPORT_ENABLED]: 'true',
    },
    module: CAMPAIGNS_MODULE,
    endpoint: 'dco-creative-performance-summary',
    graph,
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
        [REPORT_PRESET.SETUP]: { columns: setupColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    sortMap: {
        [SPENT.field]: SPENT.field,
    },
    searchPlaceholderMsgId: 'app.reports.dcoByCampaignCreative.search.placeholder',
    searchField: FIELDS.TEMPLATE_NAME.field,
    filters: [],
    initialFilters: [],
    rowHeight: 62,
    comfortableRowHeight: 112,
};

export default dcoCreativeReportConfig;
